<template>
    <svg class="ml-[-2px]" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.825 21.0833L7.45 14.351L2 9.82292L9.2 9.22396L12 2.875L14.8 9.22396L22 9.82292L16.55 14.351L18.175 21.0833L12 17.5135L5.825 21.0833Z"
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    name: 'StarIcon',

    props: {
        color: {
            type: String,
            default: '#eebe60',
        },
    },
};
</script>
